import { Messages } from '../langs';

const fr: Messages = {
    common: {
        loading: 'Chargement',
        unauthorized: 'Accès non-autorisé, veuillez vous reconnecter',
        not_found: 'Ressource demandée non-trouvée',
        unknown_error: 'Erreur inconnue',
        hide_details: 'Moins de détails',
        ok: 'OK',
        cancel: 'Annuler',
        edit: 'Modifier',
        config: 'Configurer',
        delete: 'Supprimer',
        freedevice: "Libérer l'appareil",
        new: 'Nouveau',
        applications: 'Applications',
        reset: 'Réinitialiser',
        noDate: 'Aucune date sélectionnée',
        actions: 'Actions',
        free_deviceapplication: "Libérer l'application",
        upload_config: 'Charger la configuration',
        file: 'Configuration par fichier',
        placeholder: 'Choisissez un fichier ou déposez-le ici...',
        drop_placeholder: 'Déposer le fichier ici...',
        browse_text: 'Parcourir',
        os: 'OS',
        device_id: "Id de l'appareil",
        device_name: "Nom de l'appareil",
        registered_date: "Date d'enregistrement",
        last_connection_date: 'Date de dernière connexion',
        error_freedevice: "Impossible de libérer l'application device",
        clusters: 'Clusters',
        users: 'Utilisateurs',
        user: 'Utilisateur',
        status: 'Statut',
        id: 'Id',
        created_at: 'Date de création',
        updated_at: 'Date de modification',
        refresh: 'Rafraîchir',
        stop: 'Stopper',
        size: 'Taille',
        config_files: 'Fichiers de configuration',
        email: 'E-mail',
        events: 'Événements'
    },

    view: {
        Login: {
            login: 'Identifiant',
            password: 'Mot de passe',
            connection: 'Connexion',
            continue: 'Continuer',
            step_credentials: 'Veuillez vous connecter',
            step_contract: 'Veuillez choisir le contrat',
            step_application: "Veuillez choisir le profil d'application",
            step_credentials_help: '',
            step_contract_help: '',
            step_application_help: '',
            lost_password: 'Mot de passe oubli\u00E9 ?',
            lost_login: 'Identifiant oubli\u00E9 ?',
            access_denied: 'Aucune vue activée pour la consultation',
            choose_contract: 'Contrat',
            choose_contract_placeholder: 'Choisir un contrat',
            choose_application: 'Application',
            choose_application_placeholder: 'Choisir une application',
            choose_application_help: '',
            error_choose_contract: 'Veuillez choisir un contrat pour continuer',
            error_choose_application: 'Veuillez choisir une application pour continuer',
            error_wrong: 'Mot de passe ou identifiant incorrect',
            error_not_linked_to_application: "Votre compte n'est lie a aucune application pour le backoffice",
            error_session_expired: 'Session expir\u00E9e, veuillez vous reconnecter',
        },
        LostPassword: {
            title: 'Mot de passe oublié',
            login: 'Identifiant',
            send: 'Envoyer',
            back_to_login: 'Retour à la connexion',
            error_wrong: 'Identifiant incorrect',
            success: 'Un email vous a été envoyé pour réinitialiser votre mot de passe',
        },
        LostLogin: {
            title: 'Identifiant oublié',
            email: 'Email',
            send: 'Envoyer',
            back_to_login: 'Retour à la connexion',
            error_wrong: 'Email incorrect',
            success: 'Un email vous a été envoyé contenant votre identifiant',
        },
        InitPassword: {
            title: 'Réinitialisation mot de passe',
            password: 'Nouveau mot de passe',
            confirm_password: 'Confirmation nouveau mot de passe',
            send: 'Envoyer',
            back_to_login: 'Retour à la connexion',
            error_invalid_token: 'Jeton invalide ou expiré',
            error_wrong_password: 'Mot de passe trop court (8 caractères minimum)',
            success: 'Votre mot de passe a été réinitialisé, vous pouvez fermer cette page',
        },
        Users: {
            title: 'Utilisateurs',
            error_unable: 'Impossible de charger les utilisateurs, veuillez essayer plus tard',
            new_item: 'Nouvel utilisateur',
            item: 'Utilisateur',
            error_create: 'Impossible de créer un nouvel utilisateur',
            name: 'Nom',
            login: 'Login',
            email: 'Email',
            phone: 'Téléphone',
            id: 'Id',
            validated_account: 'Compte validé',
            locked_account: 'Compte bloqué',
            vod_email_notifications_enabled: 'Emails des nouvelles VODs',
            contracts: 'Contrats',
            list_application_free: 'Liste des applications libre',
            password: 'Mot de passe',
            new_password: 'Nouveau mot de passe',
            new_password_hint: 'Laisser vide pour conserver le mot de passe actuel.',
            link_user: 'Associer un utilisateur au contrat',
            user_to_link: 'Utilisateur',
            search_user_placeholder: 'Rechercher par nom, login ou email',
            no_user_found: 'Aucun utilisateur à associer',
            unlink_user: 'Dissocier l\u2019utilisateur du contrat',
            unlink_user_confirm: 'L\u2019utilisateur perdra l\u2019accès à ce contrat et à ses applications. Son compte est conservé.',
            error_password_too_short: 'Mot de passe trop court.'
        },
        Contracts: {
            id: 'Id',
            title: 'Contrats',
            clusters: 'Clusters',
            error_unable: 'Impossible de charger les contrats, veuillez essayer plus tard',
            new_item: 'Nouveau contrat',
            item: 'Contrat',
            error_create: 'Impossible de créer un nouveau contrat',
            name: 'Nom',
            client_name: 'Nom du client',
            client_contact_name: 'Nom du contact client',
            client_contact_email: 'Email du contact client',
            client_contact_phone: 'Téléphone du contact client',
            invoice_address_0: 'Adresse (facturation)',
            invoice_address_1: 'Adresse (facturation) (suite)',
            invoice_city: 'Ville (facturation)',
            invoice_company: 'Société (facturation)',
            invoice_email: 'Email (facturation)',
            invoice_phone: 'Téléphone (facturation)',
            invoice_vat_nb: 'Taux de TVA (facturation)',
            invoice_zipcode: 'Code postal (facturation)',
            application_config_directory: 'Dossier des configurations des applications',
            application_counter: 'Compteur des applications',
            user_counter: 'Compteur des utilisateurs',
            vod_auto_publish: 'Auto-publication VODs'
        },
        Applications: {
            search_device: "Rechercher un appareil : nom, id, utilisateur, OS",
            no_device_found: 'Aucun appareil trouvé',
            id: 'Id',
            contract_id: 'Id du contrat',
            title: 'Applications',
            error_unable: 'Impossible de charger les applications, veuillez essayer plus tard',
            new_item: 'Ajouter une application',
            item: 'Application',
            error_create: "Impossible d'ajouter une nouvelle application",
            edit_rights: 'Modifier les droits',
            error_rights_unable: "Impossible de charger les droits de l'application",
            error_update_rights: "Impossible de mettre a jour les droits de l'application",
            subscription_start_date: "Date de début d'abonnement",
            subscription_end_date: "Date de fin d'abonnement",
            config_directory: 'Dossier de configuration',
            conflict: 'Conflict error',
            switch_role: 'Rôle du switch',
            description: 'Description',
            list_user: 'Liste des utilisateurs',
            max_device_counter: "Nombre de connexion à l'application",
            list_devices: 'Liste des applicationdevices',
            date_order_error: "La date de début d'abonnement doit être antérieure à la date de fin d'abonnement.",
            config_files: "Fichiers de configruration",
            application_type_id: "Id type d'application",
            application_right_template_id: 'Id modele de droits application',
            use_device_counter: "Compteur d'appareils",
            application_type_name: "Nom type d'application",
        },
        ApplicationTypes: {
            id: 'Id',
            name: 'Nom',
            web_url: 'URL web',
            apple_app_store_url: 'URL App Store Apple',
            google_play_store_url: 'URL Google Play Store',
            title: "Types d'application",
            error_unable: "Impossible de charger les types d'application, veuillez essayer plus tard",
            new_item: "Nouveau type d'application",
            item: "Type d'application",
            error_create: "Impossible de creer le type d'application",
            error_update: "Impossible de mettre a jour le type d'application",
            error_delete: "Impossible de supprimer le type d'application",
            edit_right_templates: 'Modeles de droits',
            error_right_templates_unable: "Impossible de charger les modeles de droits pour ce type d'application",
            new_template: 'Nouveau modele',
            template_name: 'Nom du modele',
            template_description: 'Description',
            is_default: 'Modele par defaut',
            error_create_template: 'Impossible de creer le modele de droits',
            error_update_template: 'Impossible de mettre a jour le modele de droits',
            error_delete_template: 'Impossible de supprimer le modele de droits',
            right_key: 'Droit',
            default_value: 'Active par defaut',
            downloads_visible: 'Visible sur la page de téléchargement',
            display_name: 'Nom affiché (téléchargements)',
            description_fr: 'Description française (téléchargements)',
            description_en: 'Description anglaise (téléchargements)',
            version: 'Version publiée',
            binaries: 'Binaires',
            downloads: 'Téléchargements',
            downloads_title: 'Binaires téléchargeables',
            downloads_hint: 'Un binaire par plateforme, publié sur ncars.isontheair.com/downloads lorsque le type est visible sur la page de téléchargement.',
            downloads_visible_short: 'Publié',
            platform: 'Plateforme',
            file: 'Fichier',
            size: 'Taille',
            updated_at: 'Mis à jour',
            no_binary: 'Aucun binaire',
            choose_file: 'Choisir un fichier…',
            upload: 'Envoyer',
            delete_binary: 'Supprimer le binaire',
            confirm_delete_binary: 'Supprimer le binaire de cette plateforme ?',
            error_upload: "Impossible d'envoyer le binaire",
            error_upload_too_large: 'Fichier trop volumineux pour le serveur (413)',
            error_downloads_disabled: "Le stockage des téléchargements n'est pas configuré sur ce serveur",
            error_delete_binary: 'Impossible de supprimer le binaire',
        },
        Clusters: {
            cluster_private_http_api_url: 'URL privée (interne) de l\'API HTTP du cluster',
            cluster_public_http_api_url: 'URL publique (externe) de l\'API HTTP du cluster',
            cluster_public_access_url: 'URL d\'accès public du cluster',
            cluster_name: 'Nom',
            error_create: "Impossible d'ajouter une nouveau cluster",
            error_unable: 'Impossible de charger les clusters, veuillez essayer plus tard',
            id: 'Id',
            item: 'Cluster',
            new_item: 'Ajouter un cluster',
            title: 'Clusters',
            cluster_api_key: "Clé d'api du cluster",
            observability: 'Supervision',
            status: 'Statut',
            online: 'En ligne',
            offline: 'Hors ligne',
            unknown: 'Inconnu',
            last_seen: 'Dernier contact il y a',
            gateways: 'Gateways',
            sources_free: 'Sources libres',
            destinations_free: 'Destinations libres',
            sessions: 'Sessions',
            ingress: 'Débit entrant',
            egress: 'Débit sortant',
            memory: 'Mémoire',
            throughput: 'Débit cumulé',
            chart_period: 'Période des graphiques',
            system_load: 'Charge système',
            gateway_availability: 'Disponibilité des gateways',
            sources: 'sources',
            destinations: 'destinations',
            no_history: "L'historique sera disponible après les premières collectes.",
            stale_snapshot: 'La dernière mesure du cluster est périmée :',
            live_logs: 'Logs en direct',
            logs_redacted: 'Données sensibles masquées',
            no_logs: 'En attente de nouveaux logs…'
        },
        Devices: {
            title: 'Appareils',
            search: "Recherche : nom ou id de l'appareil, login ou nom de l'utilisateur",
            application: 'Application',
            contract: 'Contrat',
            user: 'Utilisateur',
            all_contracts: 'Tous les contrats',
            all_applications: 'Toutes les applications',
            no_devices: 'Aucun appareil',
        },
        Sessions: {
            cluster_id: 'Id du cluster',
            cluster_name: 'Nom du cluster',
            error_create: "Impossible d'ajouter une nouvelle session",
            error_unable: 'Impossible de charger les sessions, veuillez essayer plus tard',
            id: 'Id',
            item: 'Session',
            new_item: 'Ajouter une session',
            title: 'Sessions',
            search: 'Recherche',
            created_at: 'Date de création',
            updated_at: 'Date de mise à jour',
            status: 'Statut',
            contract_id: 'Id du contrat',
            decryption_key: 'Clé de décryptage',
            encryption_key: "Clé d'encryption",
            sdp: 'Fichier SDP',
            tags: 'Tags',
            contract_name: 'Contrat',
            source: 'Source',
            consumer_count: 'Consommateurs',
            source_application: 'Application source',
            unknown_source: 'Source inconnue',
            unknown_device: 'Boîtier inconnu',
            unknown_application: 'Application inconnue',
            graph_title: 'Liens de la session',
            show_ended_consumers: 'Afficher les consommations terminées',
            all_contracts: 'Tous les contrats',
            all_clusters: 'Tous les clusters',
            all_source_applications: 'Toutes les applications source',
            all_consumers: 'Avec ou sans consommateur',
            with_consumers: 'Avec consommateurs',
            without_consumers: 'Sans consommateur',
            finished_at: 'Fin',
            started_at: 'Début',
            ended: 'Terminé',
            port: 'Port',
            end_released: 'libéré',
            end_gone: 'perdu',
            end_session_finished: 'session terminée',
            hls_video: 'HLS vidéo',
            hls_audio: 'HLS audio',
            hls_metadata: 'HLS métadonnées',
        },
        Mosaics: {
            title: 'Mosaïques',
            new_mosaic: 'Nouvelle mosaïque',
            item: 'Mosaïque',
            description: 'Description',
            tags: 'Tags',
            output_url: 'URL de destination',
            output_video_port: 'Port de destination vidéo',
            created_at: 'Date de création',
            updated_at: 'Date de modification',
            id: 'Id',
            sdp: 'Fichier SDP',
            status: 'Statut',
            video_output_port: 'Port de destination vidéo',
            video_output_SSRC: 'SSRC de la sortie vidéo',
            created: 'Created',
            session_ids: 'Session Ids',
        },
        SwitchSources: {
            title: 'Switch sources',
            item: 'Switch source',
            error_create: "Impossible d'ajouter un nouveau switch source",
            error_unable: "Impossible de charger les switches sources, veuillez essayer plus tard",
            new_item: 'Nouveau switch source',
            external_switch_source_id: 'Id switch source externe',
            switch_owner_contract_id: 'Id contrat',
            switch_source_display_order: "Ordre d'affichage",
            switch_source_id: "Id",
            switch_source_is_connected: "Connecté",
            switch_source_name: "Nom",
            switch_source_picture_url: "Url image",
            nomade_gateway_config_dir: "Répertoire configuration Nomade Gateway",
            switch_source_nomade_gateway_config_dir: "Répertoire configuration Nomade Gateway",
            switch_source_type: "Type de switch source"
        },
        SwitchDestinations: {
            title: 'Switch destinations',
            item: 'Switch destination',
            error_create: "Impossible d'ajouter un nouveau switch destination",
            error_unable: "Impossible de charger les switches destination, veuillez essayer plus tard",
            new_item: 'Nouveau switch destination',
            switch_destination_destination_application_id: 'Id application',
            switch_owner_contract_id: 'Id contrat',
            switch_destination_display_order: "Ordre d'affichage",
            switch_destination_id: "Id",
            switch_destination_is_connected: "Connecté",
            switch_destination_name: "Nom",
            switch_destination_destination_switch_source_id: "Source",
            switch_destination_destination_type: "Type"
        },
        Register: {
            application_id: "Id d'application",
            confirm_password: 'Confirmation nouveau mot de passe',
            contract_id: "Id de contract",
            error_unable: "Inscription impossible, veuillez réessayer plus tard ...",
            success: "Inscription réussie, veuillez consulter vos emails pour finaliser l'inscription.",
            title: "Inscription",
            user_email: "Email",
            login_already_taken: "Login déjà utilisé, veuillez en choisir un autre.",
            application_type_name: 'Type d\'application'
        },
        HLS: {
            audio_sessions_ids: "Ids sessions audios",
            metadata_sessions_ids: "Ids sessions metadatas",
            video_session_id: "Ids sessions vidéos",
            created: "Crée",
            created_at: "Crée le",
            description: "Description",
            directory_path: "Chemin répertoire",
            id: "Id",
            item: "Hls",
            new_hls: "Nouveau HLS",
            status: "Statut",
            title: "HLS",
            updated_at: "Mis à jour le",
            video_decoder: "Décodeur vidéo",
            video_encoder: "Encodeur vidéo",
            video_encoder_scales: "Résolutions d'encodage vidéo",
            playback: "Lire la vidéo",
            expert_mode: "Mode expert",
            expert_width: "Largeur",
            expert_height: "Hauteur",
            expert_fps: "FPS",
            expert_bitrate_kbps: "Bitrate (kbps)",
            expert_positive_fields_error: "Les champs du mode expert doivent être des nombres positifs."
        },
        VOD: {
            folder_ids: "Dossiers personnels",
            car_id: 'ID voiture',
            car: 'Voiture',
            id: "Id",
            contract: "Contrat",
            contract_id: "Contrat",
            all_contracts: "Tous les contrats",
            all_statuses: "Tous les statuts",
            created: "Créée",
            created_at: "Créée le",
            duration_seconds: "Durée",
            item: "Vod",
            name: "Nom",
            new_vod: "Nouvelle VOD",
            published: "Publiée",
            has_bus_can: "Données BUS CAN",
            has_laps: 'Tour complet',
            status: "Statut",
            thumbnail: "Miniature",
            thumbnail_mime_type: "Type MIME de la miniature",
            title: "VOD",
            type: "Type",
            playback: "Lire la vidéo",
            event_id: "Id Événement",
            close: "Fermer (upload terminé)",
            rename: "Renommer",
            put_event: "Associer un événement",
            no_event: "Aucun événement",
            loading_events: "Chargement des événements…",
            delete: "Supprimer",
            latitude: "Latitude",
            longitude: "Longitude",
            event: "Événement",
            first_chunk_live_start_datetime_utc: "Temps de démarrage du premier chunk",
            origin: "Origine",
            origin_device: "Boîtier",
            origin_application: "Application",
            origin_user: "Utilisateur",
            filter_device: "Filtrer sur ce boîtier",
            clear_filter: "Retirer le filtre",
            merged_into_vod_id: "Fusionnée dans la VOD",
            merge_parts: "Parties fusionnées",
            parts: "parties",
            show_parts: "Afficher les parties",
            part_start: "Début",
            gap: "Écart",
            merge: "Fusion…",
            merge_title: "Fusionner des VOD",
            merge_help: "Seules les VOD de la même voiture (ou du même boîtier si la voiture est inconnue), terminées, qui se suivent à moins d'1 h d'intervalle peuvent être fusionnées. Les VOD d'origine sont conservées et la fusion peut être annulée.",
            merge_master: "VOD principale",
            merge_total: "Durée totale",
            merge_no_candidates: "Aucune VOD ne peut être ajoutée à la suite de celle-ci.",
            merge_save: "Enregistrer",
            merge_separate_all: "Tout séparer",
            merge_reason_UNKNOWN_DEVICE: "Le boîtier d'origine de cette VOD est inconnu.",
            merge_reason_NOT_UPLOADED: "Cette VOD n'est pas terminée (upload en cours ou absent).",
            merge_reason_NO_CLUSTER: "Cette VOD n'est rattachée à aucun cluster.",
            merge_reason_MERGED_INTO_OTHER: "Cette VOD est déjà une partie d'une autre VOD."
        },
        Cars: {"title": "Voitures", "number": "Numéro", "description": "Description", "image": "Image", "new_car": "Nouvelle voiture", "remove_image": "Retirer l’image", "delete_help": "Supprimer cette voiture ? Les VODs seront conservées sans association à cette voiture.", "invalid_image": "Choisissez une image JPEG, PNG, WebP ou GIF de 2 Mo maximum.", "duplicate_number": "Ce numéro existe déjà dans ce contrat."},
        Events: {
            contract_id: 'Id contrat',
            created_at: 'Date de création',
            created: 'Crée',
            description: 'Description',
            geojson: 'GeoJSON',
            id: 'Id',
            item: 'Événement',
            name: 'Nom',
            new_event: 'Nouvel Événement',
            title: 'Événements',
            download_geojson: 'Télécharger GeoJSON',
            event_map: 'Carte de l’événement avec tracé et barycentre',
            centroid: 'Barycentre (latitude, longitude)',
            vod_ids: 'IDs des VOD',
            vod_count: 'Nombre de VOD',
            start_datetime_utc: "Date et heure de début (UTC)",
            end_datetime_utc: "Date et heure de fin (UTC, optionnelle)",
            debrief_enabled: 'Débrief activé',
            debrief_enabled_help: "Désactivé, les lecteurs ne peuvent plus ouvrir le débrief de cet événement ni de ses VOD.",
        }
    },

    components: {
        Menu: {
            title: 'ISONTHEAIR',
            connect: 'Se connecter',
            contracts: 'Contrats',
            users: 'Utilisateurs',
            clusters: 'Clusters',
            application_types: "Types d'application",
            devices: 'Appareils',
            sessions: 'Sessions',
            mosaics: 'Mosaïques',
            hls: 'HLS',
            vod: 'VOD'
        },
        UserInfos: {
            disconnect: 'Déconnexion',
        },
        LanguageSelector: {
            lang: 'Langue',
        },
        MultiSelect: {
            tagPlaceholder: "Appuyer sur entrée pour créer l'option",
            placeholder: 'Sélectionner des options',
            selectLabel: 'Appuyer sur entrée',
            deselectLabel: 'Appuyer sur entrée pour retirer',
            selectedLabel: 'Selectionnée',
        },
    },

    options: {
        ApplicationOss: {
            ANDROID: 'Android',
            IOS: 'IOS',
            LINUX: 'Linux',
            MACOS: 'Mac OS',
            WINDOWS: 'Windows',
        },
        ApplicationSwicthRoles: {
            SWITCH_DESTINATION: 'Destination',
            SWITCH_SOURCE: 'Source',
            SWITCH_NO_ROLE: 'Aucun rôle',
        },
        UserTypes: {
            USER_ADMIN: 'Administrateur',
            USER_CUSTOMER: 'Utilisateur',
            USER_RESELLER: 'Revendeur',
            USER_DIRECTOR: 'Producteur',
        },
        SwitchSourceTypes: {
            SWITCH_SOURCE_TYPE_APPLICATION: 'Application',
            SWITCH_SOURCE_TYPE_GATEWAY: 'Gateway'
        }
    },
};

export default fr;
